import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppService from "../../../services/app.service";
import Loader from "../../../components/loader";
import AlertDialogSlide from "../../../components/deleteModal";
import Table from "../../../components/Table";
import Layout from "../../../layout/Layout";
import moment from "moment";

let message = "";

const getStatusInfo = (record) => {
  const end = moment.utc(record.endDate).startOf("day");
  const today = moment.utc().startOf("day");

  let label = record.active ? "Active" : "InActive";
  let sort = record.active ? 0 : 2;

  if (end.isBefore(today)) {
    label = "Expired";
    sort = 1;
  }

  return { label, sort };
};

const Messages = (props) => {
  const [data, setData] = useState([]);
  const [isShowingModal, setIsShowingModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageId, setMessageId] = useState(0);
  const [columnSchema] = useState([
    {
      dataField: "id",
      text: "ID",
      sort: true,
      classes: "content-body",
      headerStyle: { minWidth: 50 },
      headerClasses: "table_header_color",
      align: "left",
    },
    {
      dataField: "title",
      text: "Title",
      sort: true,
      headerStyle: { width: 200 },
      classes: "content-body",
      headerClasses: "table_header_color",
      align: "left",
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
      headerStyle: { minWidth: 300 },
      classes: "paragraph-in-table content-body",
      headerClasses: "table_header_color",
      align: "left",
    },
    {
      dataField: "startDate",
      text: "Start Date",
      sort: true,
      headerStyle: { width: 120 },
      classes: "paragraph-in-table content-body",
      headerClasses: "table_header_color",
      align: "left",
      formatter: (cell, record) => {
        return (
          <Fragment>
            {record.startDate != null && record.startDate !== ""
              ? moment(record.startDate).utc().format("MM-DD-YYYY")
              : "MM-DD-YYYY"}
          </Fragment>
        );
      },
    },
    {
      dataField: "endDate",
      text: "End Date",
      sort: true,
      classes: "paragraph-in-table content-body",
      headerClasses: "table_header_color",
      align: "left",
      headerStyle: { width: 120 },
      formatter: (cell, record) => {
        return (
          <Fragment>
            {record.endDate != null && record.endDate !== ""
              ? moment(record.endDate).utc().format("MM-DD-YYYY")
              : "MM-DD-YYYY"}
          </Fragment>
        );
      },
    },
    {
      dataField: "active",
      text: "Active",
      sort: true,
      classes: "content-body",
      headerClasses: "table_header_color",
      align: "left",
      headerStyle: { width: 100 },
      formatter: (cell, record) => {
        return <label>{getStatusInfo(record).label}</label>;
      },

      sortValue: (cell, record) => {
        return getStatusInfo(record).sort;
      },

      filterValue: (cell, record) => {
        return getStatusInfo(record).label;
      },
    },
    {
      dataField: "action",
      text: "Action",
      classes: "action text-center",
      headerStyle: { width: 110 },
      headerClasses: "text-center",
      align: "center",
      formatter: (_, record) => {
        return (
          <Fragment>
            <Link
              className="btn btn-primary btn-sm"
              to={`/messages/edit/${record.id}`}
              style={{ marginRight: "5px" }}
            >
              <i className="fa fa-edit" title="Edit Message" />
            </Link>
            <button
              className="btn btn-danger btn-sm buttons"
              onClick={() => deleteRecord(record.id, record.title)}
              style={{ marginRight: "5px" }}
            >
              <i className="fa fa-trash" title="Delete Message" />
            </button>
          </Fragment>
        );
      },
    },
  ]);

  const handleOpenDeleteModal = () => setIsShowingModal(true);
  const handleCloseDeleteModal = () => setIsShowingModal(false);

  const deleteRecord = (recordId, name) => {
    setMessageId(recordId);
    message = name;
    handleOpenDeleteModal();
  };

  const handleProcess = async () => {
    handleCloseDeleteModal();
    setLoading(true);
    const messages = await AppService.delete(messageId, "messages");
    if (messages.status === 200) {
      setData(messages.data);
    }
    setLoading(false);
  };

  const loadData = async () => {
    setLoading(true);
    const messages = await AppService.getAll("messages/getAll");
    setData(messages.data);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div>
      <Layout
        title="Message Center"
        history={props.history}
        activeClientLoginMessagesLink={true}
        showBreadCrumb={true}
      >
        <section className="tables">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-close">
                    <div className="dropdown">
                      <Link className="dropdown-toggle" to="/messages/add">
                        <i className="fas fa-plus" title="Add Message" />
                      </Link>
                    </div>
                  </div>
                  <div className="card-header d-flex align-items-center">
                    <h3 className="sub-heading">Messages</h3>
                  </div>

                  <div className="card-body">
                    <div className="table-responsive data-table-wrapper table-heading">
                      <Table
                        data={data.length > 0 ? data : []}
                        columns={columnSchema}
                        remote={false}
                        id="value"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
      {loading && (
        <div className="overlay">
          <Loader loading={loading} />
        </div>
      )}
      <AlertDialogSlide
        show={isShowingModal}
        handleNo={handleCloseDeleteModal}
        handleYes={handleProcess}
        title="Delete Message"
      >
        <p className="fields-font">
          Are you sure you want to delete the message{" "}
          <span className="span">{message}</span> ?
        </p>
      </AlertDialogSlide>
    </div>
  );
};

export default Messages;
